function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M102.749,115.197h-7.5c-1.656,0-3-1.343-3-3s1.344-3,3-3h4.5v-6.5c0-1.657,1.344-3,3-3 c1.657,0,3,1.343,3,3v9.5C105.749,113.854,104.406,115.197,102.749,115.197z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M35.144,115.197h-7.5c-1.657,0-3-1.343-3-3v-9.5c0-1.657,1.343-3,3-3s3,1.343,3,3v6.5h4.5 c1.657,0,3,1.343,3,3S36.801,115.197,35.144,115.197z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M27.644,91.23c-1.657,0-3-1.343-3-3v-15.8c0-1.657,1.343-3,3-3s3,1.343,3,3v15.8 C30.644,89.888,29.301,91.23,27.644,91.23z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M27.644,30.697c-1.657,0-3-1.343-3-3v-9.5c0-1.657,1.343-3,3-3h7.5c1.657,0,3,1.343,3,3s-1.343,3-3,3h-4.5 v6.5C30.644,29.354,29.301,30.697,27.644,30.697z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M58.853,21.197H47.832c-1.657,0-3-1.343-3-3s1.343-3,3-3h11.021c1.657,0,3,1.343,3,3 S60.51,21.197,58.853,21.197z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M102.749,30.697c-1.656,0-3-1.343-3-3v-6.5h-4.5c-1.656,0-3-1.343-3-3s1.344-3,3-3h7.5 c1.657,0,3,1.343,3,3v9.5C105.749,29.354,104.406,30.697,102.749,30.697z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M102.749,91.23c-1.656,0-3-1.343-3-3V72.43c0-1.657,1.344-3,3-3c1.657,0,3,1.343,3,3V88.23 C105.749,89.888,104.406,91.23,102.749,91.23z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M82.562,21.197H71.541c-1.657,0-3-1.343-3-3s1.343-3,3-3h11.021c1.657,0,3,1.343,3,3 S84.219,21.197,82.562,21.197z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M59.734,115.197H48.712c-1.657,0-3-1.343-3-3s1.343-3,3-3h11.021c1.657,0,3,1.343,3,3 S61.391,115.197,59.734,115.197z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M83.442,115.197H72.422c-1.657,0-3-1.343-3-3s1.343-3,3-3h11.021c1.657,0,3,1.343,3,3 S85.1,115.197,83.442,115.197z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M27.644,60.964c-1.657,0-3-1.343-3-3V42.163c0-1.657,1.343-3,3-3s3,1.343,3,3v15.801 C30.644,59.621,29.301,60.964,27.644,60.964z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#595A59",
  d: "M102.749,60.963c-1.656,0-3-1.343-3-3v-15.8c0-1.657,1.344-3,3-3c1.657,0,3,1.343,3,3v15.8 C105.749,59.62,104.406,60.963,102.749,60.963z"
});

var SvgNessunDato = function SvgNessunDato(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "130.394px",
    height: "130.394px",
    viewBox: "0 0 130.394 130.394",
    enableBackground: "new 0 0 130.394 130.394",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNessunDato, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nessunDato.2a5431d1.svg";
export { ForwardRef as ReactComponent };